@if (link()) {
  <a seFeLink="low" [routerLink]="link()" [target]="target()">
    <ng-container *ngTemplateOutlet="nameCell"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="nameCell"></ng-container>
}

<ng-template #nameCell>
  <div class="product-details-link">
    <div [class]="{'product-image-container': true, 'border-gray': isValidImage(images())}">
      @if (isValidImage(images())) {
        <img [src]="images()![0].src" alt="{{ images()![0].alt || name() }}" class="product-image" />
      }
    </div>
    @if (link()) {
      <p seFeLink class="table-row">{{ name() }}</p>
    } @else {
      <p class="table-row">{{ name() }}</p>
    }
  </div>
</ng-template>
